import { CreateMapByObj } from "../../CreateMapByObjectUtils";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var AccountAdditionalInfoItemFormatingType;
(function (AccountAdditionalInfoItemFormatingType) {
    AccountAdditionalInfoItemFormatingType[AccountAdditionalInfoItemFormatingType["None"] = 0] = "None";
    AccountAdditionalInfoItemFormatingType[AccountAdditionalInfoItemFormatingType["AssetBalance"] = 1] = "AssetBalance";
    AccountAdditionalInfoItemFormatingType[AccountAdditionalInfoItemFormatingType["CustomAsset"] = 2] = "CustomAsset";
})(AccountAdditionalInfoItemFormatingType || (AccountAdditionalInfoItemFormatingType = {}));
export var AccountTradeStatus;
(function (AccountTradeStatus) {
    AccountTradeStatus[AccountTradeStatus["ACTIVE_STATUS"] = 0] = "ACTIVE_STATUS";
    AccountTradeStatus[AccountTradeStatus["CLOSED_STATUS"] = 1] = "CLOSED_STATUS";
    AccountTradeStatus[AccountTradeStatus["SUSPEND_STATUS"] = 2] = "SUSPEND_STATUS";
    AccountTradeStatus[AccountTradeStatus["TRADING_DISABLED_RISK_STATUS"] = 3] = "TRADING_DISABLED_RISK_STATUS";
    AccountTradeStatus[AccountTradeStatus["FINRA_DAY_TRADER_PATTERN_STATUS"] = 4] = "FINRA_DAY_TRADER_PATTERN_STATUS";
    AccountTradeStatus[AccountTradeStatus["LIQUIDATION_ONLY_STATUS"] = 5] = "LIQUIDATION_ONLY_STATUS";
})(AccountTradeStatus || (AccountTradeStatus = {}));
export var AccountSeal;
(function (AccountSeal) {
    AccountSeal[AccountSeal["Unspecified"] = -1] = "Unspecified";
    AccountSeal[AccountSeal["Demo"] = 0] = "Demo";
    AccountSeal[AccountSeal["Live"] = 1] = "Live";
    AccountSeal[AccountSeal["Contest"] = 2] = "Contest";
    AccountSeal[AccountSeal["Funded"] = 3] = "Funded";
    AccountSeal[AccountSeal["Challenge"] = 4] = "Challenge";
})(AccountSeal || (AccountSeal = {}));
export var AccountVisibilityType;
(function (AccountVisibilityType) {
    AccountVisibilityType[AccountVisibilityType["VISIBILITY_FLAG_OWN"] = 1] = "VISIBILITY_FLAG_OWN";
    AccountVisibilityType[AccountVisibilityType["VISIBILITY_FLAG_GROUP"] = 2] = "VISIBILITY_FLAG_GROUP";
    AccountVisibilityType[AccountVisibilityType["VISIBILITY_FLAG_LINK"] = 4] = "VISIBILITY_FLAG_LINK";
    AccountVisibilityType[AccountVisibilityType["VISIBILITY_FLAG_MAM"] = 8] = "VISIBILITY_FLAG_MAM"; // - видимость по мам группе
})(AccountVisibilityType || (AccountVisibilityType = {}));
export var AccountType;
(function (AccountType) {
    AccountType[AccountType["SingleCCY"] = 0] = "SingleCCY";
    AccountType[AccountType["MultiAsset"] = 1] = "MultiAsset";
    AccountType[AccountType["ClosedFund"] = 2] = "ClosedFund";
    AccountType[AccountType["OpenedFund"] = 3] = "OpenedFund";
})(AccountType || (AccountType = {}));
const AccountSealLocalizationKeys = {
    [AccountSeal.Unspecified]: 'Accounts.AccountDetails.Mode.Demo',
    [AccountSeal.Demo]: 'Accounts.AccountDetails.Mode.Demo',
    [AccountSeal.Live]: 'Accounts.AccountDetails.Mode.Live',
    [AccountSeal.Contest]: 'Accounts.AccountDetails.Mode.Contest',
    [AccountSeal.Funded]: 'Accounts.AccountDetails.Mode.Funded',
    [AccountSeal.Challenge]: 'Accounts.AccountDetails.Mode.Challenge'
};
export function getAccountSealLocalizationKey(accountSeal) {
    return AccountSealLocalizationKeys[accountSeal];
}
export const AccountTypeMap = CreateMapByObj(AccountType);
export function getAccountTypeStr(value) {
    return AccountTypeMap[value] || AccountTypeMap[AccountType.SingleCCY];
}
